(() => {
  const bool = (value) => String(value) === 'true';
  const number = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const canUseStorage = (() => {
    try {
      const key = '__newsletter_popup_test__';
      window.localStorage.setItem(key, '1');
      window.localStorage.removeItem(key);
      return true;
    } catch (_error) {
      return false;
    }
  })();

  const modals = document.querySelectorAll('[data-newsletter-popup]');
  if (!modals.length) return;

  modals.forEach((modal) => {
    const config = {
      trigger: modal.dataset.trigger || 'time_delay',
      delaySeconds: number(modal.dataset.delaySeconds, 6),
      scrollPercent: number(modal.dataset.scrollPercent, 45),
      repeatDays: number(modal.dataset.repeatDays, 14),
      showOnMobile: bool(modal.dataset.showOnMobile),
      homepageOnly: bool(modal.dataset.homepageOnly),
      hideForLoggedIn: bool(modal.dataset.hideForLoggedIn),
      overlayClickCloses: bool(modal.dataset.overlayClickCloses),
      customerLoggedIn: bool(modal.dataset.customerLoggedIn),
      designMode: bool(modal.dataset.designMode),
      pageType: modal.dataset.pageType || '',
      storageKey: modal.dataset.storageKey || 'newsletter-popup-dismissed',
      maxWidth: number(modal.dataset.maxWidth, 720),
      overlayOpacity: number(modal.dataset.overlayOpacity, 55),
    };

    modal.style.setProperty('--newsletter-popup-max-width', `${config.maxWidth}px`);
    modal.style.setProperty(
      '--newsletter-popup-overlay-opacity',
      `${Math.max(0, Math.min(100, config.overlayOpacity)) / 100}`
    );

    const closeControls = modal.querySelectorAll('[data-newsletter-popup-close]');
    const overlay = modal.querySelector('[data-newsletter-popup-overlay]');
    const successMessage = modal.querySelector('.newsletter-popup__message--success');
    const formWrapper = modal.querySelector('[data-newsletter-success-redirect-enabled]');
    const successRedirectEnabled = bool(formWrapper?.dataset.newsletterSuccessRedirectEnabled);
    const successRedirectUrl = formWrapper?.dataset.newsletterSuccessRedirectUrl?.trim() || '';
    const successRedirectDelaySeconds = number(
      formWrapper?.dataset.newsletterSuccessRedirectDelaySeconds,
      0
    );
    let isOpen = false;
    let hasTriggered = false;

    const isDismissed = () => {
      if (!canUseStorage || config.designMode) return false;
      const raw = window.localStorage.getItem(config.storageKey);
      if (!raw) return false;
      const until = Number(raw);
      return Number.isFinite(until) && Date.now() < until;
    };

    const dismissForPeriod = () => {
      if (!canUseStorage) return;
      const days = Math.max(0, config.repeatDays);
      const until = Date.now() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(config.storageKey, String(until));
    };

    const openModal = () => {
      if (isOpen) return;
      isOpen = true;
      modal.classList.remove('hidden');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      const focusTarget = modal.querySelector('input, button, [href], select, textarea');
      if (focusTarget) focusTarget.focus();
    };

    const closeModal = () => {
      if (!isOpen) return;
      isOpen = false;
      modal.classList.remove('is-open');
      modal.classList.add('hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      dismissForPeriod();
    };

    const isEligible = () => {
      if (config.hideForLoggedIn && config.customerLoggedIn) return false;
      if (!config.showOnMobile && window.innerWidth < 750) return false;
      if (config.homepageOnly && config.pageType !== 'index') return false;
      if (isDismissed()) return false;
      return true;
    };

    const triggerOpen = () => {
      if (hasTriggered || !isEligible()) return;
      hasTriggered = true;
      openModal();
    };

    closeControls.forEach((node) => node.addEventListener('click', closeModal));
    if (overlay && config.overlayClickCloses) {
      overlay.addEventListener('click', closeModal);
    } else if (overlay) {
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.cursor = 'default';
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });

    if (successMessage) {
      openModal();
      dismissForPeriod();
      if (successRedirectEnabled && successRedirectUrl) {
        window.setTimeout(() => {
          window.location.assign(successRedirectUrl);
        }, Math.max(0, successRedirectDelaySeconds) * 1000);
      }
      return;
    }

    if (config.designMode) {
      openModal();
      return;
    }

    if (!isEligible()) return;

    if (config.trigger === 'scroll_depth') {
      const onScroll = () => {
        const doc = document.documentElement;
        const maxScroll = doc.scrollHeight - window.innerHeight;
        if (maxScroll <= 0) {
          window.removeEventListener('scroll', onScroll);
          triggerOpen();
          return;
        }
        const scrolled = (window.scrollY / maxScroll) * 100;
        if (scrolled >= config.scrollPercent) {
          window.removeEventListener('scroll', onScroll);
          triggerOpen();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }

    if (config.trigger === 'exit_intent') {
      const onMouseOut = (event) => {
        if (event.relatedTarget || event.toElement) return;
        if (event.clientY > 15) return;
        document.removeEventListener('mouseout', onMouseOut);
        triggerOpen();
      };
      document.addEventListener('mouseout', onMouseOut);
      return;
    }

    window.setTimeout(triggerOpen, Math.max(0, config.delaySeconds) * 1000);
  });
})();
